import { RacemapColors } from './common';

export const DEFAULT_GEO_LINESTRING_OPACITY = 0.8;
export const DEFAULT_GEO_LINESTRING_LINE_WIDTH = 3;
export const DEFAULT_GEO_LINESTRING_COLOR = `${RacemapColors.PaleBlue}cc`;
